export class ShipmentTypeCode {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const CODE_NAME = 'ShipmentTypeCode'

export const t1 = new ShipmentTypeCode('01', 'Standard or regular filings')
export const t2 = new ShipmentTypeCode('02', 'To Order Shipments')
export const t3 = new ShipmentTypeCode('03', 'HHG/PE')
export const t4 = new ShipmentTypeCode('04', 'Military')
export const t5 = new ShipmentTypeCode('05', 'Diplomatic')
export const t6 = new ShipmentTypeCode('06', 'Carnets')
export const t7 = new ShipmentTypeCode('07', 'US Returned Goods')
export const t8 = new ShipmentTypeCode('08', 'FTZ Shipments')
export const t9 = new ShipmentTypeCode('09', 'International Mail Shipments')
export const t10 = new ShipmentTypeCode('10', 'Outer Continental Shelf Shipments')
export const t11 = new ShipmentTypeCode('11', 'Informal')
export const Shipment_Type_Code = [t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11]

export function getShipmentTypeCodeByCode(code) {
  return Shipment_Type_Code.find(el => el.code === code)
}
